import React from "react";

import img1 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/clients-1.svg";
import img2 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/marketshare-1.svg";
import img3 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/trophies-1.svg";
import img4 from "../assets/images/sidom/fotos/Nosotros/iconos_web_vieja/trust-1.svg";

export default function StatsCards() {
  const stats = [
    {
      icon: img1,
      value: 90,
      description: "de proyectos ganados",
    },
    {
      icon: img2,
      value: 0,
      description: "de rotación de clientes",
    },
    {
      icon: img3,
      value: 60,
      description: "del Market Share",
    },
    {
      icon: img4,
      value: 60,
      description: "clientes de últimos 3 años",
    },
  ];

  return (
    <div className="flex flex-col md:flex-row mt-[100px] mb-[100px] justify-items-center dark:bg-sidom-blue hover:border-sidom-orange  bg-sidom-light  gap-10 container">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="flex flex-col rounded-3xl border border-sidom-light  bg-sidom-blue bg-gradient-to-t from-sidom-orange to-transparent w-[300px] h-[300px] items-center justify-center  text-sidom-dark  dark:text-sidom-light  "
        >
          <div className="flex items-center justify-center w-20 h-20   rounded-full mb-4">
            <img
              src={stat.icon}
              alt="img"
              className="w-12 h-12 object-contain"
            />
          </div>

          <div className="text-nowrap text-sidom-light  w-full flex justify-center  text-3xl font-bold   ">
            <p>{stat.value} %</p>
          </div>
          <div className="text-center text-sidom-light">
            <p>{stat.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
